import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo!");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-zinc-300 bg-white p-8">
        <div className="text-center mb-6">
          <Lock className="mx-auto" size={28} />
          <h1 className="font-serif-display text-3xl font-bold mt-2">Painel Administrativo</h1>
          <p className="font-sans-ui text-sm text-zinc-500 mt-1">Chiquinho o 01 do Acre</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="overline">E-mail</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full mt-1 border border-zinc-300 px-3 py-2 font-sans-ui" data-testid="login-email" />
          </div>
          <div>
            <label className="overline">Senha</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full mt-1 border border-zinc-300 px-3 py-2 font-sans-ui" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="w-full bg-black text-white py-3 font-sans-ui text-sm uppercase tracking-widest font-semibold hover:bg-red-700 disabled:opacity-50" data-testid="login-submit">
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
        <p className="text-xs font-sans-ui text-zinc-400 mt-4 text-center">Acesso restrito · Administrador · Editor · Jornalista</p>
      </div>
    </div>
  );
}
